import { render, staticRenderFns } from "./InterfaceManagementSection.vue?vue&type=template&id=5b88bff4&scoped=true"
import script from "./InterfaceManagementSection.vue?vue&type=script&lang=js"
export * from "./InterfaceManagementSection.vue?vue&type=script&lang=js"
import style0 from "./InterfaceManagementSection.vue?vue&type=style&index=0&id=5b88bff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88bff4",
  null
  
)

export default component.exports